/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_See_DetailsInputs */

const en_directory_vibebids_see_details = /** @type {(inputs: Directory_Vibebids_See_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`see details`)
};

const zh_directory_vibebids_see_details = /** @type {(inputs: Directory_Vibebids_See_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看详情`)
};

/**
* | output |
* | --- |
* | "see details" |
*
* @param {Directory_Vibebids_See_DetailsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_see_details = /** @type {((inputs?: Directory_Vibebids_See_DetailsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_See_DetailsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_see_details(inputs)
	return zh_directory_vibebids_see_details(inputs)
});
export { directory_vibebids_see_details as "directory.vibebids.see_details" }